import { calcDisplaySafeHeight } from './helpers';
import { documentObserver, observerCallback } from '@/helpers/fixedBody.js';
import { registerAllComponents } from '@/componentRegistry';
import { initDefaultConfig, getConfig } from '@/config';

export function bootstrapApp() {
    initDefaultConfig();
    registerAllComponents();

    document.addEventListener('DOMContentLoaded', () => {
        calcDisplaySafeHeight();
        observerCallback();
        documentObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });
        const config = getConfig();
        if (config?.events?.load) {
            document.dispatchEvent(new Event(config.events.load));
        }
    });
}
